import { Grid } from "@mui/material";
import FormTextField from "components/FormFields/FormTextField";
import React from "react";

const OtherDeviceInformation = ({ fields, onUpdate, isError }) => {
  const otherImplantInformation = fields?.otherDeviceInformation;
  return (
    <Grid container spacing={2} className="mt-3">
      <Grid item xs={12} spacing={2}>
        <h2 data-label="other-device-information-header">
          Other Implanted Device Information
        </h2>
        <Grid container spacing={2}>
          {otherImplantInformation.burdenPercent && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.burdenPercent}
                label="Burden Percentage"
                disabled={true}
                data-text="other-device-information-burden-percentage-field"
              />
            </Grid>
          )}
          {otherImplantInformation.mode && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.mode}
                label="Mode"
                disabled={true}
                data-text="other-device-information-mode-field"
              />
            </Grid>
          )}
          {otherImplantInformation.maxTrackingRate && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.maxTrackingRate}
                label="Max Tracking Rate"
                disabled={true}
                data-text="other-device-information-max-tracking-rate-field"
              />
            </Grid>
          )}
          {otherImplantInformation.maxSensorRate && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.maxSensorRate}
                label="Max Sensor Rate"
                disabled={true}
                data-text="other-device-information-max-sensor-rate-field"
              />
            </Grid>
          )}
          {otherImplantInformation.lowRate && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.lowRate}
                label="Low Rate"
                disabled={true}
                data-text="other-device-information-low-rate-field"
              />
            </Grid>
          )}
          {otherImplantInformation.pavDelayHigh && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.pavDelayHigh}
                label="PAV Delay High"
                disabled={true}
                data-text="other-device-information-pav-delay-high-field"
              />
            </Grid>
          )}
          {otherImplantInformation.pavDelayLow && (
            <Grid item xs={3}>
              <FormTextField
                fullWidth
                value={otherImplantInformation.pavDelayLow}
                label="PAV Delay Low"
                disabled={true}
                data-text="other-device-information-pav-delay-low-field"
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OtherDeviceInformation;
